"use client";

import clsx from "clsx";
import { memo, useMemo } from "react";

const getPositionByDayOfWeek = (date) => {
  const dateObj = new Date(date);
  const dayOfWeek = dateObj.getDay();

  if (dayOfWeek === 1) {
    return "left";
  } else if (dayOfWeek === 0) {
    return "right";
  } else {
    return "center";
  }
};

const DayButton = memo(
  ({
    day,
    children,
    isHoliday = false,
    showCheckoutToolTip = false,
    ...buttonProps
  }) => {
    const position = useMemo(
      () => getPositionByDayOfWeek(day.date),
      [day.date],
    );

    const isSelected = buttonProps?.modifiers?.selected;
    return (
      <button
        {...buttonProps}
        className="relative !mx-auto flex h-full !w-full cursor-pointer flex-col items-center justify-center"
      >
        {showCheckoutToolTip && isSelected && (
          <div
            className={clsx(
              "bg-foreground-muted absolute bottom-full z-[1] mb-2.5 w-max transform rounded-sm text-sm font-normal text-white",
              position === "left" && "left-0",
              position === "right" && "right-0",
              position === "center" && "left-1/2 -ml-15",
            )}
          >
            <div className="relative w-full px-3 py-2">
              {showCheckoutToolTip}
              <span
                className={clsx(
                  "bg-foreground-muted absolute top-full -mt-1 h-2 w-2 rotate-45 transform",
                  position === "left" && "left-5",
                  position === "right" && "right-5",
                  position === "center" && "left-1/2 -ml-1",
                )}
              ></span>
            </div>
          </div>
        )}
        {isHoliday && (
          <div className="bg-tertiary-emphasis absolute top-[2px] right-[2px] h-[6px] w-[6px] rounded-full"></div>
        )}
        <div
          className={clsx(
            "flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-semibold",
            isSelected && !buttonProps?.modifiers?.range_middle
              ? "bg-primary rounded-full text-white"
              : "",
            buttonProps?.modifiers?.range_middle && isSelected
              ? "text-primary rounded-none"
              : "",
          )}
        >
          <span className="text-sm">{children}</span>
        </div>
        <span className="text-foreground-muted h-full w-full flex-1 bg-white pt-[3px] text-xs leading-none font-thin" />
      </button>
    );
  },
);

DayButton.displayName = "DayButton";

export default DayButton;
